import { Button, styled } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCustomRoutes } from '../../hooks';

const StyledViewMapButton = styled(Button)(({ theme }) => ({
  bottom: theme.spacing(1),
  left: theme.spacing(1),
  position: 'absolute',
  zIndex: 502,
  whiteSpace: 'nowrap',
  backgroundColor: theme.palette.primary.contrastText,
  color: `${theme.palette.primary.main} !important`,
  borderRadius: theme.shape.borderRadius * 2,
}));

export const ViewMapButton: FC<{ entityId: string }> = ({ entityId }): JSX.Element => {
  const { t } = useTranslation(['common']);
  const { things } = useCustomRoutes();
  const navigate = useNavigate();

  return (
    <StyledViewMapButton size='small' variant="contained" onClick={() => navigate(`/map/${things}/${entityId}`, { state: { previousLocations: location, shouldSetView: true } })} data-testid="view-full-map-button">
      {t('common:component.map.labels.view-full')}
    </StyledViewMapButton>
  );
};
